import React from "react";
import "./Footer.scss";
import { Nav } from "react-bootstrap";
import { ReactComponent as Logo } from "./revlogo.svg";
// eslint-disable-next-line no-unused-vars
import logo from "./mofowhite.png";

const Footer = () => {
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-4 text-left">
            <Logo className="logo" />
            <ul className="social-icons">
              <li>
                <a
                  href="https://www.facebook.com/clozesure"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.twitter.com/clozesure"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-twitter"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/clozesure"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </li>
            </ul>
          </div>
          <div className="col-md-2 mt-4 text-left">
            <h5 className="">Homeowners</h5>
            <ul>
              <li>
                <Nav.Link
                  onClick={() =>
                    openInNewTab("https://clozesure.q.starberry.com/faqs//")
                  }
                  className="nav-text"
                >
                  FAQs
                </Nav.Link>
              </li>
            </ul>
          </div>
          <div className="col-md-2 mt-4 text-left">
            <h5 className="">Businesses</h5>
            <ul>
              <li>
                <Nav.Link
                  onClick={() =>
                    openInNewTab(
                      "https://clozesure.q.starberry.com/estate-agents//"
                    )
                  }
                  className="nav-text"
                >
                  For Estate Agents
                </Nav.Link>
              </li>
              <li>
                <Nav.Link
                  onClick={() =>
                    openInNewTab(
                      "https://clozesure.q.starberry.com/conveyancers//"
                    )
                  }
                  className="nav-text mt-4"
                >
                  For Conveyancers
                </Nav.Link>
              </li>
            </ul>
          </div>
          <div className="col-md-2 mt-4 text-left">
            <h5 className="">How it Works</h5>
            <ul>
              <li>
                <Nav.Link
                  onClick={() =>
                    openInNewTab("https://clozesure.q.starberry.com/partners//")
                  }
                  className="nav-text"
                >
                  Partners
                </Nav.Link>
              </li>
              <li>
                <Nav.Link
                  onClick={() =>
                    openInNewTab(
                      "https://clozesure.q.starberry.com/acquisition//"
                    )
                  }
                  className="nav-text mt-4"
                >
                  Acquisition Process
                </Nav.Link>
              </li>
            </ul>
          </div>
          <div className="col-md-2 mt-4 text-left align-right">
            <h5 className="">About Us</h5>
            <ul>
              <li>
                <Nav.Link
                  onClick={() =>
                    openInNewTab(
                      "https://clozesure.q.starberry.com/meet-the-team//"
                    )
                  }
                  className="nav-text"
                >
                  Team
                </Nav.Link>
              </li>
              <li>
                <Nav.Link
                  onClick={() =>
                    openInNewTab(
                      "https://clozesure.q.starberry.com/latest-news//"
                    )
                  }
                  className="nav-text mt-4"
                >
                  News
                </Nav.Link>
              </li>
              <li>
                <Nav.Link
                  onClick={() =>
                    openInNewTab(
                      "https://clozesure.q.starberry.com/contact-clozesure//"
                    )
                  }
                  className="nav-text mt-4"
                >
                  Contact Us{" "}
                </Nav.Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom text-left">
          <div className="row">
            <div className="col-md-2">
              <p>&copy; {new Date().getFullYear()} ClozeSure</p>
            </div>
            <div className="col-md-1">
              <p>
                <Nav.Link
                  onClick={() =>
                    openInNewTab("https://clozesure.q.starberry.com/privacy//")
                  }
                  className="nav-text"
                >
                  Privacy
                </Nav.Link>
              </p>
            </div>
            <div className="col-md-4">
              <p>
                <Nav.Link
                  onClick={() =>
                    openInNewTab(
                      "https://clozesure.q.starberry.com/terms-and-conditions//"
                    )
                  }
                  className="nav-text"
                >
                  Terms and Conditions
                </Nav.Link>
              </p>
            </div>
            <div className="col-md-5 right-align">
              <p>
                Site by:
                <a
                  href="https://www.mofo.dev"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={logo} alt="Mofo" className="icon" />
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
